import { Avatar, Box, ListItemAvatar, Stack, Typography } from '@mui/material';
import { IconHeadset } from '@shared/assets/images/svgs';
import React from 'react';
import { messageTimeCalculation } from './utils';
import type { TestingConversationViewMessage } from './useTestingConversationMessages';

interface TestingConversationMessageProps {
  messageItem: TestingConversationViewMessage;
  actorName?: string;
  isStacked?: boolean;
  timeSincePreviousMessage?: number;
}

export const TestingConversationMessage: React.FC<TestingConversationMessageProps> = ({
  messageItem,
  actorName,
  isStacked,
  timeSincePreviousMessage,
}: TestingConversationMessageProps) => {
  const { actor } = messageItem;
  const isAgent: boolean = actor === 'agent';

  return (
    <Box
      display="flex"
      alignItems="flex-end"
      flexDirection={isAgent ? 'row' : 'row-reverse'}
      sx={{
        mt: isStacked ? '3px' : '16px',
        mb: '2px',
        ml: isAgent ? 0 : '52px',
      }}>
      {isAgent && !isStacked && (
        <ListItemAvatar sx={{ minWidth: 'unset', mr: '10px' }}>
          <Avatar
            sx={{
              width: 32,
              height: 32,
              backgroundColor: '#eef2ff',
              border: '1px solid #e0e7ff',
            }}>
            <IconHeadset style={{ fontSize: 16 }} />
          </Avatar>
        </ListItemAvatar>
      )}
      {isAgent && isStacked && <Box sx={{ width: 32, mr: '10px', flexShrink: 0 }} />}

      <Box
        display="flex"
        flexDirection="column"
        alignItems={isAgent ? 'flex-start' : 'flex-end'}
        sx={{ maxWidth: '75%' }}>
        {!isStacked && (
          <Typography sx={{ fontWeight: 600, fontSize: '12px', color: '#374151', mb: '4px' }}>
            {actorName || actor}
          </Typography>
        )}
        <Box
          sx={{
            p: '10px 14px',
            borderRadius: isAgent ? '4px 14px 14px 14px' : '14px 4px 14px 14px',
            backgroundColor: isAgent ? '#f8f9fb' : '#4f6ef7',
            color: isAgent ? '#1f2937' : '#ffffff',
            fontSize: '14px',
            lineHeight: 1.55,
            wordBreak: 'break-word',
            boxShadow: isAgent ? '0 1px 2px rgba(0,0,0,0.04)' : '0 1px 3px rgba(79,110,247,0.2)',
          }}>
          {messageItem.message}
        </Box>
        <Stack direction="row" alignItems="center" sx={{ mt: '4px' }}>
          <Typography sx={{ fontSize: '11px', color: '#b0b8c4' }}>
            {messageTimeCalculation(messageItem.createdAt)}
          </Typography>
          {timeSincePreviousMessage !== undefined && (
            <Typography sx={{ fontSize: '11px', color: '#b0b8c4', ml: '6px' }}>
              ( +{timeSincePreviousMessage} sec )
            </Typography>
          )}
        </Stack>
      </Box>
    </Box>
  );
};
